/* Enable Microphone Apr 13, 2024 */
/* Amended for placement May 30, 2025 */
/* Add noteType Feb 28, 2026 */
/* Add m_closeNotes,button,CSS Jul 11, 2026 */
<template lang="pug">
	div(:class="p_class" )
		button.close-notes-btn(@click="m_closeNotes") x
		div(class="notes-header") Notes/Comments
		div(class="d-flex")
			<b-button v-if="p_mode=='edit'" variant="primary" title="Add a note" @click="m_addNote"><fa-icon icon="plus" /></b-button>
			<b-button v-if="p_mode=='edit'" :disabled="d_selectedNoteIdx==null" variant="danger"  title="Remove current note" @click="m_removeNote"><fa-icon icon="trash-alt" /></b-button>
			<b-button v-if="!d_paused && p_mode=='edit'" variant="success" title="Microphone on" @click="m_toggleListener"><fa-icon  icon="microphone"/></b-button>
			<b-button v-if="d_paused && p_mode=='edit'" :disabled="d_selectedNoteIdx==null" variant="danger" title="Microphone off" @click="m_toggleListener"><fa-icon icon="microphone-slash" /></b-button>
			<b-button v-if="p_mode=='edit'" :disabled="!d_newNotes" variant="primary" title="Save" @click="m_saveNotes"><fa-icon icon="save" /></b-button>
			<b-button  variant="primary" title="Refresh" @click="m_refeshNotes"><fa-icon icon="sync" /></b-button>
			div(class="searchBar" )
				<b-input id="searchBar" class="input-search" v-model="d_search" type="search" placeholder="Search Notes" size=70 @search="m_search"></b-input>
				<fa-icon v-if="!c_search" icon="search" />
		b-table(
			ref="selectableTable"
			small
			:fields="d_fields"
			:items="c_notes"
			sticky-header="300px"
			selectable
			select-mode="single"
			selected-variant=""
			show-empty
			thead-class="d-none"
			@row-selected="m_onRowSelected"
			@row-dblclicked="m_rowDblClicked"
			)
				template(v-slot:cell(note)="data")
					.note-header
						img.small-round-profile(:src="m_profilePicURL(data.item.teamMemberId)")
						span(v-html="data.item.teamMemberName")
						span.note-date(v-html="data.item.createdUTC")
					div(style="display:flex;")
						span Note Type:
						b-form-select(
							v-if="data.item.new"
							:id="'noteType-' + data.index"
							v-model="data.item.noteType"
							:options="d_noteTypes"
							class="note-type-select"
							)
						span(v-else class="note-type-label") {{m_getNoteType(data.item.noteType||"comment")}}
					div(v-if="data.item.new && d_selectedNoteIdx !== null && data.index === d_selectedNoteIdx")
						vue-editor(
							id="editorId"
							ref="editorId"
							v-model="data.item.note"
							:editor-toolbar="customToolbar"
							@focus="m_handleFocus"
							@blur="m_handleBlur"
							)
					div(v-else)
						.note-content.notes(v-html="data.item.note")
				template(#empty="scope")
					span No Notes	
</template>
<script>
import {fn_deleteAppNote,fn_getAppNotes,fn_saveAppNotes} from "@/utils/api.js";
import util,{kbdpAlert,fn_profilePicURL} from "@/utils/util.js";
import {VueEditor} from "vue2-editor";
import {userInfo} from "@/utils/ref-data.js";
import vSelect from "vue-select";
export default {
	name: "kt-notes",
	components: {VueEditor,
	             "v-select":vSelect},
	created() {
	var params={
			recordContext:this.p_recordContext,
			recordId:this.p_recordId
			};
			//fn_getNotes(this,params);	
			fn_getAppNotes(params).then((resp) =>
				{
				if (!resp.error && resp.recordData) 
				{
				if(resp.recordData.length>0) {
					resp.recordData.forEach(n=>{
					let teamMemberName=n.teamMemberId==this.d_teamMemberId?'You':n.teamMemberName;
					var note={noteId:n.noteId,teamMemberId:n.teamMemberId,teamMemberName:teamMemberName,new:false,image: fn_profilePicURL(n.teamMemberId),  
					createdUTC:new Date(n.createdUTC+'Z').toLocaleString(),createdById: n.createdById,note:n.note,noteType:n.noteType};
					this.d_notes.push(note);
					});
				}
			}
           });
	},
	mounted() {},
	data() {
		return {
			d_notes:[],
			d_paused: true,
			d_speechRecognizer: null,
			d_update: false,
			d_noteID: -1,
			d_content:null,
			d_selectedNoteId:null,
			d_selectedNoteIdx:null,
			d_selectedNote:null,
			d_currentNote:null,
			d_teamMember: userInfo.getUserInfo().teamMember,
			d_teamMemberId: userInfo.getUserInfo().teamMember.teamMemberId,
			d_newNote: 
				{
				noteId:null,
				note:null,
				teamMemberName:'You',
				teamMemberId:userInfo.getUserInfo().teamMember.teamMemberId,
				new: true,
				noteType:"comment",
				tempId:null
        },
		d_fields:[{label: "",key: "note"}],
		d_customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{align: ""}, {align: "center"},{align: "right"},{align: "justify"}],
        ["blockquote", "code-block"]
        ],
      editorSettings: {
        modules: {
          clipboard: {
            matchers: [[Node.ELEMENT_NODE, this.customQuillClipboardMatcher]]
          }
        }
      },
		d_newNotes:0,
		d_search:null,
		d_searchNote:null,
		d_noteTypes:[{text:"Comment",value:"comment"},
		             {text:"Meeting",value:"meeting"},
					 {text:"Email-Inbound",value:"emailInbound"},
					 {text:"Email-Outbound",value:"emailOutbound"},
					 {text:"SMS-Inbound",value:"smsInbound"},
					 {text:"SMS-Outbound",value:"smsOutbound"},
					 {text:"Phone-Inbound",value:"phoneInbound"},
					 {text:"Phone-Outbound",value:"phoneOutbound"}
					 ]
		};
	},
	props: {
		p_recordContext:String,
		p_recordId:String,
		p_mode:String,
		p_save:Boolean,
		p_class:String,
	},
	computed: {
	c_notes(){
	
	//- Searching
		var v_searchNotes=[...this.d_notes];
		var v_searchMatches=[];
		var newNote=null;
		var noteMatched=null;
		var matches=null;
		
		
		
		if(this.d_searchNote) {
			console.log(`Searching for ${this.d_searchNote}`);
			var regex= new RegExp(this.d_searchNote,'gi');
			
			
			v_searchNotes.forEach(n=>{
				newNote={...n};
				noteMatched=false;
				

				if(regex.test(n.note)){
					noteMatched=true;
					matches=n.note.match(regex);
					var note=n.note;
					matches.forEach(m=>{
							note=note.replaceAll(m,`<span style="background-color:yellow;">${m}</span>`);
						});
					newNote.note=note;
					}
					
				if(regex.test(n.teamMemberName)){
					noteMatched=true;
					matches=n.teamMemberName.match(regex);
					var teamMemberName=n.teamMemberName;
					matches.forEach(m=>{
							teamMemberName=teamMemberName.replaceAll(m,`<span style="background-color:yellow;">${m}</span>`);
						});
					newNote.teamMemberName=teamMemberName;
				}
				
				if(regex.test(n.createdUTC)){
					noteMatched=true;
					matches=n.createdUTC.match(regex);
					var createdUTC=n.createdUTC;
					matches.forEach(m=>{
							createdUTC=createdUTC.replaceAll(m,`<span style="background-color:yellow;">${m}</span>`);
						});
					newNote.createdUTC=createdUTC;
				} 
				
				
				if(noteMatched){
					v_searchMatches.push(newNote);
				}
			
			});
			
			
		} 
	
	return this.d_searchNote?v_searchMatches:this.d_notes;
	
	},
	c_currentNote:{
				get(){return this.d_notes[this.d_selectedNoteIdx].note;},
				set(value){this.d_notes[this.d_selectedNoteIdx].note=value;}
			},
	c_search(){return this.d_search?this.d_search.length:null;},
	},
	methods: {
	m_rowDblClicked(){	this.d_selectedNoteIdx=null;
						this.d_selectedNoteId=null;
						},
	m_profilePicURL(teamMemberId){return fn_profilePicURL(teamMemberId);},
	m_onRowSelected(row){
		
		if(row.length>0){
			this.d_selectedNote=row[0];
			this.d_selectedNoteId=row[0].noteId;
			this.d_selectedNoteIdx=row[0].new?this.d_notes.findIndex(n=>n.tempId==row[0].tempId):this.d_notes.findIndex(n=>n.noteId==row[0].noteId);
			this.d_currentNote=this.d_notes[this.d_selectedNoteIdx].note;
		}
		console.log('this.d_selectedNoteIdx');
		console.log(this.d_selectedNoteIdx);
	},
    m_toggleListener() {
	
      this.d_paused = !this.d_paused;
      if(!this.d_paused&&this.d_selectedNoteIdx != null) this.m_startConverting(this.d_selectedNoteIdx);
      if(this.d_paused&&this.d_speechRecognizer) this.d_speechRecognizer.stop();
    },
	m_addNote() {
		var d_note={...this.d_newNote};
		d_note.tempId=Date.now();
		d_note.createdUTC=(new Date()).toLocaleString();
		let temp = [...this.d_notes];
		temp.unshift(d_note);	
		this.d_notes =[...temp];
		this.d_selectedNoteIdx=0;
		this.d_selectedNoteId=this.d_notes[0].tempId;
		this.d_newNotes=this.d_newNotes+1;
		window.sessionStorage.setItem('unsaved-changes', true);
    },
	m_saveNotes(){
		var params={recordContext:this.p_recordContext,
					recordId:this.p_recordId,
					recordData:this.d_notes.filter(n=>n.note != null&&n.new).map(n=>{return {noteId:n.noteId,note:n.note, noteType:n.noteType};})
					};
		fn_saveNotes(this,params);
		this.d_selectedNoteIdx=null;
		this.d_selectedNoteId=null;
		this.d_paused=true;
		this.$refs.selectableTable.clearSelected();
		this.d_newNotes=0;
	},
	m_removeNote(){
	fn_deleteNote(this);
	},
	m_handleFocus() {
      document.addEventListener("keydown", this.handleKeyDown);
    },
    m_handleBlur() {
      document.removeEventListener("keydown", this.handleKeyDown);
    },
    m_handleKeyDown(e) {
      if (e.keyCode === 222) {
        e.preventDefault();
      }
    },
	m_countNotes(){return this.d_notes.length;},
    m_startConverting(idx) {

      if (!this.d_paused) {
        this.d_speechRecognizer = new webkitSpeechRecognition();
        this.d_speechRecognizer.continuous = true;
        this.d_speechRecognizer.interimResults = true;
        this.d_speechRecognizer.lang = 'en-US';
        this.d_speechRecognizer.start();

	
        var finalTranscripts = this.d_notes[this.d_selectedNoteIdx].note;

        this.d_speechRecognizer.onresult = (event) => {
          var interimTranscripts = '';
          for (var i = event.resultIndex; i < event.results.length; i++) {
            var result = event.results[i];
            for (var j = result.length - 1; j >= 0; j--) {
              var word = result[j].transcript.trim();
              if (word !== "") {

                if (result.isFinal && result[0].confidence > 0.1) {
                  this.m_toggleListener();
                  finalTranscripts += this.m_filterSingleQuotes(word) + ' ';
                } else {
                  interimTranscripts += this.m_filterSingleQuotes(word) + ' ';
                }

              }
            }
          }

			if(finalTranscripts) this.d_notes[this.d_selectedNoteIdx].note = finalTranscripts.trim().replace('null','');
        };
        this.d_speechRecognizer.onerror = function (event) {
			console.log('Unable to load the listener.');
			}
		}
	},
    m_filterSingleQuotes(text) {
      return text.replace(/'/g, '');
    },
	m_search(e) {this.d_searchNote = e.target.value || null;},
	m_refeshNotes(){var params={recordContext:this.p_recordContext,recordId:this.p_recordId, refresh:true};
					fn_getNotes(this,params);
					},
	m_getNoteType(noteType){return this.d_noteTypes.filter(n=>n.value==noteType)[0]["text"];},
	m_closeNotes() {this.$emit("close","")},
	},
watch: {
		p_save(nv,ov){if(nv&&this.d_newNotes) this.m_saveNotes();},
		p_mode(nv,ov){if(nv=='view') this.d_paused=true;}
 }
		
};
function fn_getNotes(vc,params){
	fn_getAppNotes(params).then((resp) =>
				{
				if (!resp.error && resp.recordData) 
				{
				if(resp.recordData.length>0) {
					var notes=[];
					resp.recordData.forEach(n=>{
					let teamMemberName=n.teamMemberId==vc.d_teamMemberId?'You':n.teamMemberName;
					var note={noteId:n.noteId,teamMemberId:n.teamMemberId,teamMemberName:teamMemberName,new:false,image: fn_profilePicURL(n.teamMemberId),  
					createdUTC:new Date(n.createdUTC+'Z').toLocaleString(),createdById: n.createdById,note:n.note,noteType:n.noteType};
					notes.push(note);
					});
					vc.d_notes=[...notes];
					if(params.refresh) kbdpAlert.showOk('Notes refreshed');
				}
	
			}
           });	
	}
function fn_saveNotes(vc,params){

  const fmtMonDD = (dateStr) => {
  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit"
     });
   };
   
 let latestNotes;

const n0 = vc.d_notes[0];
const n1 = vc.d_notes[1];

latestNotes = n0.new
  ? fmtMonDD(new Date()) + ": " + (n0.note || "")
  : fmtMonDD(n0.createdUTC) + ": " + (n0.note || "");

if (n1) {
  latestNotes += "\n" + fmtMonDD(n1.createdUTC) + ": " + (n1.note || "");
}
	fn_saveAppNotes(params).then(resp => {
		if (resp.error || resp.errorMessage) {
			let msg = `Unable to save Notes ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		else {
				if(!vc.p_save) kbdpAlert.showOk('Notes saved successfully');
				vc.d_notes.filter(n=>(n.new)).forEach(n=>{n.new=false;});
				window.sessionStorage.removeItem('unsaved-changes');
				vc.$emit("savedNotes",latestNotes);
			}
		});

     
	}
function fn_deleteNote(vc) {
	let content = {
		titleText: 'Confirm Delete',
		message1:`Are you sure you want to delete this Note?`,
	};
	
	let cm = util.fn_getModal_confirm(vc, content);

	vc.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then((resp) => {
		if (!resp) return;

		kbdpAlert.showDeleting(`Note`);

		if(!vc.d_selectedNote.new)
		fn_deleteAppNote(vc.d_selectedNoteId).then(resp => {
			if (resp.error || !resp.status) {
				kbdpAlert.showErr("Unable to delete Note");
				return;
			}
			
		});
		
		let temp = [...vc.d_notes];
		temp.splice(vc.d_selectedNoteIdx, 1);
		vc.d_notes = [...temp];
		vc.d_deleteEnabled=false;
		kbdpAlert.showOk("Note Deleted Successfully.");
		window.sessionStorage.removeItem('unsaved-changes');
	});
}
</script>
<style scoped lang="less">
summary {list-style: none}
summary::-webkit-details-marker {display: none; }
details summary::before { 
  content:"🡒"; 
  color: #1E90FF; 
  /* you can style it however you want, use background-image for example */
}

/* By using [open] we can define different styles when the disclosure widget is open */
details[open] summary::before { 
  content:"🠣";  /*"🡑"*/ 
  color: #1E90FF; 
}
.Note-item{
			border-bottom: solid 0.1em #dee2e6;
			//border-bottom: 1px solid #000;
	}
.btn-add, .btn-remove {
		font-size: 0.85em;
		padding: 0.3em 0.2em;
		margin: 0 0.1em;
		border-radius: 0.2em;
		line-height: 1em;
		opacity: 0.5;
		border: none;
		width: 20px;
			}
.speech-btn {
      width: 35px;
      height: 35px;
      position: absolute;
      top: 80%;
      right: 3%;
      cursor: pointer;
    }
.zoom {
  padding: 0px;
  background-color: green;
  transition: transform .2s;
  width: 15px;
  height:20px;
  margin: 0 auto;
}
.zoom:hover {
  -ms-transform: scale(1.2); /* IE 9 */
  -webkit-transform: scale(1.2); /* Safari 3-8 */
  transform: scale(1.2); 
}
.btns {
			border: none;
			min-width: 20px;
			text-align: right;
			padding: 0 0.2em;
			button.btn {
				font-size: 0.85em;
				padding: 0.3em 0.2em;
				margin: 0 0.1em;
				border-radius: 0.2em;
				line-height: 1em;
				opacity: 0.5;
				border: none;
				width: 30px;
			}
		}
.noteSummary{
	color:#1E90FF;
	}
.notes {
    border: 1px solid lightgrey;
    border-radius: 12px;
    background: white;
	pointer-events: none;
	cursor: none;
.note-content {
	width: 100%;
  }
 }
.table td,.table th {
    vertical-align: top;
    border:none;
}
.table thead th {
        border:none;
		}
.primary{color:#007bff;}
.ql-editor {
    min-height: 70px !important;
    font-size: 16px;
}
#editorId {
    min-height: 70px !important;
    font-size: 16px;
}
.note-header{
    background: lightgray;
	pointer-events: none;
	cursor: none;
	}
.dropdown-edit1 {
  position: absolute;
  background-color: #f1f1f1;
  min-width: 500px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  top: 35px;
  z-index: 9;
  overflow-y:auto;
  margin-left:-360px;  //600px;
  text-align: left;
}
.dropdown-edit2 {
  position: absolute;
    background-color: #f1f1f1;
    min-width: 500px;
    box-shadow: 0 8px 16px 0 rgba(0,0,0,.2);
    top: 30px;
    z-index: 9;
    overflow-y: auto;
    margin-left:970px;
	text-align: left;
}dropdown-view {
  position: absolute;
    background-color: #f1f1f1;
    min-width: 500px;
    box-shadow: 0 8px 16px 0 rgba(0,0,0,.2);
    top: 30px;
    z-index: 9;
    overflow-y: auto;
    margin-left:800px;
	text-align: left;
}
v.notes-header {
		display:flex;
		padding: 0.2em 0.4em;
		background-color: #83BEEB;      //#6c757d;
		color: #fff;
		margin-bottom: 0.0em;
	}
.searchBar {
		position: relative;
		width: 100%;
		div.input {
			padding: 0.155em 0.2em;
			padding-right: 1.5em;
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
			border-radius: 0.25rem;
			border: 1px solid #ced4da;
			}
	.btn-clear,
    > svg[data-icon="search"] {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 12em;
      font-size: 0.8em;
      opacity: 0.4;
      &.btn-clear {
        background-color: #e9ecef;
        &:hover {
          opacity: unset;
        }
      }
    }
  div.input.styled-input {
      border: 0px;
      border-radius: 0px;
      border-bottom: 1px solid #000000;
    }
}
.input-search {
		padding: 0.4em;
		margin-left: 10px;
		width: 250px;  
		font-size: 0.9em;
		border-style: outset;
		border-right:none;
		border-left:none;
		&:focus {
			box-shadow: 0em 0.01em 0.01em 0.05em #ced4da;
		}
	}
.small-round-profile {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.btn {margin-right:0.1em;}
.note-header {
  width: 100%;
  display: flex;
  align-items: center;
}

.note-type-label {
  margin-left: 10px;
}

.note-type-select {
  width: 150px;
  max-height:200px;
  overflow-y:auto;
}

.note-date {
  margin-left: auto;
}

.note-content {
  text-align: left;
  width: 100%;
}
.close-notes-btn {
    position1: absolute;
    top: 6px;
    right: 6px;
    color: red;
    border: none;
	background-color:transparent;
    width: 24px;
    height: 24px;
    font-weight: bold;
    cursor: pointer;
    line-height: 20px;
    text-align: center;
    transition: background-color 0.2s ease;
    z-index: 10;
	float:right;
}
.close-notes-btn:hover {
    color: #28a745; /* green */
}
.close-notes-btn:focus {
    border: none;
	outline: none;
}
.p_class1 {
    position: relative;
}

</style>